import axios from 'axios';

import {WebRTCServerSource} from 'enums';
import {platformUtils} from 'utils';

import {API_URL} from './constants';

const openPage = (source: WebRTCServerSource) => axios.post(`${API_URL}/test/video/open-page`, {
    source, platform: platformUtils.getPlatformInfo()
});

const startSession = (source: WebRTCServerSource) => axios.post(`${API_URL}/test/video/start-session`, {source});

const stopSession = (source: WebRTCServerSource) => axios.post(`${API_URL}/test/video/stop-session`, {source});

export const testVideoApi = {
    openPage,
    startSession,
    stopSession
};
